
import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import axios from "axios";

const CATEGORIES = [
  { key: "starters", label: "Starters" },
  { key: "mains", label: "Mains" },
  { key: "main", label: "Main" }, // Add this for parent items
  { key: "desserts", label: "Desserts" },
  { key: "softdrinks", label: "Soft Drinks" },
  { key: "beverages", label: "Beverages" },
];

const CUISINES = ["Indian", "Chinese", "South Indian", "Continental", "Beverage", "Hot", "Cold"];
const EVENTS = ["Wedding", "Birthday", "Corporate", "Anniversary", "Bachelor", "House Party"];
const BUDGETS = [
  { key: "lt100", label: "Below ₹100", match: (p) => p < 100 },
  { key: "100to200", label: "₹100 – ₹200", match: (p) => p >= 100 && p <= 200 },
  { key: "gt200", label: "Above ₹200", match: (p) => p > 200 },
];

export default function CateringFilter({ onNext }) {
  const [data, setData] = useState([]);
  const [specialRequests, setSpecialRequests] = useState("");

  const handleSubmitEnquiry = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");

      if (!cart || Object.keys(cart).length === 0) {
        alert("❌ Please select at least one item.");
        return;
      }

      // Get stored enquiry data from localStorage
      const storedEnquiry = localStorage.getItem('cateringEnquiry');
      if (!storedEnquiry) {
        alert("❌ No enquiry data found. Please fill the event form first.");
        return;
      }

      const enquiryData = JSON.parse(storedEnquiry);

      // Extract dish IDs from cart
      const dishIds = Object.values(cart).map(c => Number(c.item.id.replace("it", "")));

      const payload = {
        // Personal details from form
        fullName: enquiryData.formData.name,
        email: enquiryData.formData.email,
        phoneNumber: enquiryData.formData.phone,

        // Event details from form
        eventType: enquiryData.formData.eventType,
        eventDate: enquiryData.formData.date,
        eventTime: enquiryData.formData.time,
        fullAddress: enquiryData.formData.location,
        city: enquiryData.formData.city,
        state: enquiryData.formData.state,
        country: enquiryData.formData.country,

        // Plate counts from form
        vegPlates: enquiryData.formData.vegPlates,
        nonVegPlates: enquiryData.formData.nonVegPlates,
        mixedPlates: enquiryData.formData.mixedPlates,

        // Additional details
        // additionalRequests: enquiryData.formData.requests,
        additionalRequests: specialRequests,
        budget: enquiryData.formData.budget || 10000,
        status: "PENDING",

        // Menu selections from current page
        items: Object.values(cart).map(c => c.item.name),
        dishId: dishIds,
      };

      console.log("Final Payload:", payload);

      const response = await axios.post(
        `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/enquiry/create/${userId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        }
      );

      alert("✅ Menu Enquiry Submitted Successfully!");

      // Clear cart and localStorage after successful submission
      setCart({});
      localStorage.removeItem('cateringEnquiry');
      localStorage.removeItem('currentEnquiryId');

      console.log("API Response:", response.data);

    } catch (error) {
      console.error("Enquiry submission error:", error);

      let errorMessage = "❌ Menu submission failed.";
      if (error.response) {
        errorMessage += `\nStatus: ${error.response.status}`;
        if (error.response.data) {
          errorMessage += `\nError: ${JSON.stringify(error.response.data)}`;
        }
      } else if (error.request) {
        errorMessage += "\nNo response from server.";
      } else {
        errorMessage += `\nError: ${error.message}`;
      }

      alert(errorMessage);
    }
  };

  // Sidebar state
  const [eventTypes, setEventTypes] = useState([]);
  const [cuisineTypes, setCuisineTypes] = useState([]);
  const [mealType, setMealType] = useState("mixed"); // veg | nonveg | mixed
  // const [activeCategories, setActiveCategories] = useState(CATEGORIES.map(c => c.key)); // show all by default
  const [activeCategories, setActiveCategories] = useState([
    "starters", "mains", "main", "desserts", "softdrinks", "beverages"
  ]);
  const [budgetKey, setBudgetKey] = useState(""); // selects a budget band
  const [selectedCategory, setSelectedCategory] = useState("");
  const navigate = useNavigate();
  // UI state
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Selection with quantities
  const [cart, setCart] = useState({}); // { [id]: { item, qty } }

  // Derived totals
  const totalItems = useMemo(
    () => Object.values(cart).reduce((s, r) => s + r.qty, 0),
    [cart]
  );
  const totalAmount = useMemo(
    () => Object.values(cart).reduce((s, r) => s + r.qty * r.item.price, 0),
    [cart]
  );

  // Helpers
  const toggleEvent = (e) =>
    setEventTypes((prev) => (prev.includes(e) ? prev.filter((x) => x !== e) : [...prev, e]));

  const toggleCuisine = (c) =>
    setCuisineTypes((prev) => (prev.includes(c) ? prev.filter((x) => x !== c) : [...prev, c]));

  const toggleCategory = (key) =>
    setActiveCategories((prev) =>
      prev.includes(key) ? prev.filter((x) => x !== key) : [...prev, key]
    );

  const visibleItems = useMemo(() => {
    return data.filter((it) => {
      // ✅ Dropdown category filter
      if (selectedCategory && it.category.toLowerCase() !== selectedCategory.toLowerCase()) {
        return false;
      }

      // ✅ Checkbox Categories
      if (!activeCategories.includes(it.category)) return false;

      // ✅ Cuisine (if any selected)
      if (cuisineTypes.length && !cuisineTypes.includes(it.cuisine)) return false;

      // ✅ Meal type
      if (mealType === "veg" && !it.isVeg) return false;
      if (mealType === "nonveg" && it.isVeg) return false;

      // ✅ Budget
      const band = BUDGETS.find((b) => b.key === budgetKey);
      if (band && !band.match(it.price)) return false;

      // ✅ Search
      if (search.trim()) {
        const s = search.toLowerCase();
        if (!(`${it.name} ${it.cuisine} ${it.category}`.toLowerCase().includes(s)))
          return false;
      }

      return true;
    });
  }, [data, activeCategories, cuisineTypes, mealType, budgetKey, search, selectedCategory]);


  const isSelected = (id) => !!cart[id];

  const toggleItem = (item) => {
    setCart((prev) => {
      const next = { ...prev };
      if (next[item.id]) {
        // unselect
        delete next[item.id];
      } else {
        next[item.id] = { item, qty: 1 };
      }
      return next;
    });
  };

  const incQty = (id) =>
    setCart((prev) => ({ ...prev, [id]: { ...prev[id], qty: prev[id].qty + 1 } }));

  const decQty = (id) =>
    setCart((prev) => {
      const q = prev[id].qty - 1;
      const next = { ...prev };
      if (q <= 0) delete next[id];
      else next[id] = { ...prev[id], qty: q };
      return next;
    });

  const selectAllVisible = () => {
    setCart((prev) => {
      const next = { ...prev };
      visibleItems.forEach((it) => {
        if (!next[it.id]) next[it.id] = { item: it, qty: 1 };
      });
      return next;
    });
  };

  const clearAll = () => setCart({});

  const handleRemove = (id) => {
    const updatedCart = { ...cart };
    delete updatedCart[id];
    setCart(updatedCart); // assuming you have setCart state updater
  };

  const goToCart = () => {
    navigate("/Categringcart"); // 👈 Cart page ka route
  };




  const handleProceed = () => {
    if (typeof onNext === "function") {
      onNext();
    } else {
      console.error("onNext prop is not a function!");
    }
  };


  useEffect(() => {
    const fetchDishes = async () => {
      try {
        const token = localStorage.getItem("authToken");

        console.log("Token:", token);
        console.log("Fetching from:", "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/dishes/getAll");

        const response = await axios.get(
          "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/dishes/getAll",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            timeout: 10000,
          }
        );

        console.log("Full API Response:", response);
        console.log("Response data:", response.data);

        // More robust data checking
        if (response.data && Array.isArray(response.data)) {
          // CORRECT mapping based on your actual API response
          const formattedData = response.data.map((item) => {
            // Determine category based on available data
            const category = determineCategory(item);
            const cuisine = determineCuisine(item);

            return {
              id: `it${item.dishId}`,
              name: item.dishName,
              category: category,
              cuisine: cuisine,
              isVeg: item.dishType === "Veg",
              price: item.effectivePrice || item.dishPrice || 0,
              originalData: item
            };
          });

          setData(formattedData);
          console.log("Formatted data:", formattedData);
        } else {
          console.error("Unexpected response format:", response.data);
          setData([]); // Set empty array as fallback
        }

      } catch (error) {
        console.error("API Error Details:", error);

        // More detailed error logging
        if (error.response) {
          console.error("Response status:", error.response.status);
          console.error("Response data:", error.response.data);
          alert(`❌ Server Error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
        } else if (error.request) {
          console.error("No response received:", error.request);
          alert("❌ Network Error: Cannot connect to server. Please check your connection.");
        } else {
          console.error("Error:", error.message);
          alert("❌ Failed to load dishes: " + error.message);
        }

        setData([]); // Set empty array on error
      }
    };

    // Add these helper functions inside the component but outside fetchDishes
    const determineCategory = (item) => {
      // Use parentId and dishName to determine category
      if (item.parentId === 0) return "main"; // Parent items
      if (item.parentId === 1) return "starters"; // Tiffines group
      if (item.parentId === 3) return "mains"; // Biryani group
      if (item.parentId === 5) return "starters"; // Soups group

      // Fallback based on dish name
      const name = item.dishName.toLowerCase();
      if (name.includes('soup')) return 'starters';
      if (name.includes('biryani')) return 'mains';
      if (name.includes('dosa')) return 'starters';

      return 'mains'; // default
    };

    const determineCuisine = (item) => {
      const name = item.dishName.toLowerCase();
      if (name.includes('biryani')) return 'Indian';
      if (name.includes('dosa') || name.includes('tiffines')) return 'South Indian';
      if (name.includes('soup')) return 'Continental';
      return 'Indian'; // default
    };

    fetchDishes();
  }, []);


  return (
    <div style={styles.page}>

      <style>{`
        .no-scrollbar { scrollbar-width: none; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .tag { font-size: 12px; padding: 2px 6px; border-radius: 999px; }
        .tag-veg { background:#e8f7ec; color:#1f7a3a; border:1px solid #bfe8cb; }
        .tag-nonveg { background:#ffecec; color:#b00020; border:1px solid #ffc5c5; }
        .pill { background:#f1f1f1; padding:6px 10px; border-radius:8px; display:inline-block; margin:4px 6px 0 0; font-size:13px; }
        .btn { padding:10px 12px; border:none; border-radius:8px; cursor:pointer; font-weight:600; }
        .btn-primary { background:#6c47ff; color:#fff; }
        .btn-ghost { background:#eee; }
        .btn-green { background:#28a745; color:#fff; }
        .btn-danger { background:#ff4d4f; color:#fff; }
        @media (max-width: 992px) {
          .layout { flex-direction: column; }
        }
      `}</style>




      <div style={styles.container} className="layout">




        <main style={styles.itemsSection} className="no-scrollbar">
          <div style={{ ...styles.itemsHeader, display: "flex", alignItems: "center", gap: "10px" }}>
            <h3 style={{ margin: 0, flex: "1", fontFamily: "sf,pro", fontSize: '30px', fontWeight: 'bold', }}> Items</h3>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              style={{
                padding: "6px 10px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">All Categories</option>
              {CATEGORIES.map((cat) => (
                <option key={cat.key} value={cat.key}>
                  {cat.label}
                </option>
              ))}
            </select>
            <button
              style={{
                padding: "6px 12px",
                fontSize: "14px",
                borderRadius: "6px",
                cursor: "pointer",
                border: "none",
                backgroundColor: "#28a745",
                color: "#fff",
              }}
              onClick={selectAllVisible}
            >
              Select All
            </button>

            <button
              style={{
                padding: "6px 12px",
                fontSize: "14px",
                borderRadius: "6px",
                cursor: "pointer",
                border: "none",
                backgroundColor: "#dc3545",
                color: "#fff",
              }}
              onClick={clearAll}
            >
              Clear All
            </button>





          </div>


          <div style={styles.itemsGrid}>
            {visibleItems.map((it) => (
              <div key={it.id} style={styles.card}>
                <div style={styles.cardTopRow}>
                  <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={isSelected(it.id)}
                      onChange={() => toggleItem(it)}
                      style={styles.checkbox}
                    />
                    <span style={styles.itemName}>{it.name}</span>
                  </label>
                  <span className={`tag ${it.isVeg ? "tag-veg" : "tag-nonveg"}`}>
                    {it.isVeg ? "Veg" : "Non-Veg"}
                  </span>
                </div>

                <div style={styles.metaRow}>
                  <span style={styles.metaBadge}>{it.category}</span>
                  <span style={styles.metaBadge}>{it.cuisine}</span>
                </div>


              </div>
            ))}
          </div>


          <div style={styles.actionBar}>
            {/* <div>{visibleItems.length} items</div> */}
            <div style={{ display: "flex", gap: 8 }}>

            </div>
          </div>
        </main>




        <aside style={styles.selectedSection} className="no-scrollbar">
          {/* Header with Selected Items + Total */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3 style={styles.heading}>Selected Items</h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "14px",
                color: "#333",
                position: "relative",
              }}
            >
              {/* Cart Icon with badge */}
              <div style={{ position: "relative" }}>
                <FaShoppingCart style={{ color: "#28a745", fontSize: "23px", marginTop: '6px', }} />
                {totalItems > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "-8px",
                      background: "#ee6521",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 6px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      lineHeight: "1",
                    }}
                  >
                    {totalItems}
                  </span>
                )}
              </div>
            </div>

          </div>

          {/* Selected List */}
          <div style={styles.selectedList}>
            {Object.values(cart).length === 0 ? (
              <p style={{ color: "#777" }}>No items selected</p>
            ) : (
              Object.values(cart).map(({ item, qty }) => (
                <div
                  key={item.id}
                  style={{
                    ...styles.selectedRow,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 600 }}>{item.name}</div>
                    <div style={{ fontSize: 12, color: "#666" }}>
                      {item.isVeg ? "Veg" : "Non-Veg"} • {item.cuisine}
                    </div>
                  </div>

                  {/* Remove (trash) button */}
                  <button
                    onClick={() => handleRemove(item.id)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    <FaTrash />
                  </button>
                </div>
              ))
            )}
          </div>

          <div style={styles.specialRequestsSection}>
            <label style={styles.specialRequestsLabel}>Special Requests </label>
            <textarea
              style={styles.specialRequestsTextarea}
              placeholder="Any special dietary requirements, allergies, or other requests..."
              value={specialRequests}
              onChange={(e) => setSpecialRequests(e.target.value)}
              rows="4"
            />
          </div>



          {/* Buttons (center aligned) */}
          <div
            style={{
              ...styles.rightButtons,
              display: "flex",
              justifyContent: "center",
              gap: "5px", // space between buttons
              fontSize: "10px",
            }}
          >
            <button
              className="btn btn-primary"
              style={{ borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "10px" }}
              onClick={handleSubmitEnquiry}
            >
              Submit Enquiry
            </button>
          </div>

        </aside>

      </div>

      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent} className="no-scrollbar">
            <h3 style={{ marginBottom: 12, textAlign: "center" }}>Selected Items</h3>

            <div style={styles.categoryGrid}>
              {["Mains Veg", "Mains Non-Veg", "Starters Veg", "Starters Non-Veg", "Drinks"].map((cat) => {
                const categoryItems = Object.values(cart).filter(({ item }) => {
                  if (cat === "Mains Veg") return item.type === "main" && item.isVeg;
                  if (cat === "Mains Non-Veg") return item.type === "main" && !item.isVeg;
                  if (cat === "Starters Veg") return item.type === "starter" && item.isVeg;
                  if (cat === "Starters Non-Veg") return item.type === "starter" && !item.isVeg;
                  if (cat === "Drinks") return item.type === "drink";
                  return false;
                });

                if (categoryItems.length === 0) return null; // skip empty category

                return (
                  <div key={cat} style={styles.categoryCard}>
                    <h4 style={styles.categoryTitle}>{cat}</h4>
                    <div>
                      {categoryItems.map(({ item, qty }, idx) => (
                        <div key={item.id} style={styles.modalItem}>
                          <div style={{ display: "flex", gap: 8 }}>
                            <span style={{ opacity: 0.6 }}>{idx + 1}.</span>
                            <div>
                              <div style={{ fontWeight: 600 }}>{item.name}</div>
                              <div style={{ fontSize: 12, color: "#666" }}>
                                {item.isVeg ? "Veg" : "Non-Veg"} • {item.cuisine}
                              </div>
                            </div>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <div style={styles.qtyRow}>x{qty}</div>
                            <div>₹{item.price * qty}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Totals Section */}
            <div style={styles.modalTotals}>
              <div style={styles.totalLine}>
                <span>Items</span>
                <span>{totalItems}</span>
              </div>
              <div style={styles.totalLine}>
                <span>Total</span>
                <span>₹{totalAmount}</span>
              </div>
            </div>

            {/* Buttons */}
            <div style={styles.modalButtonsRow}>
              <button className="btn btn-ghost" onClick={() => setShowModal(false)}>
                Close
              </button>
              <button className="btn btn-green">Add to Cart</button>
              <button className="btn btn-primary">Proceed to Checkout</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

/* ------------------ STYLES ------------------ */
const styles = {
  // Add these to your styles object in CateringFilter.js
specialRequestsSection: {
  marginBottom: '15px',
},
specialRequestsLabel: {
  display: 'block',
  marginBottom: '8px',
  fontWeight: '600',
  fontSize: '14px',
  color: '#333',
},
specialRequestsTextarea: {
  width: '100%',
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid #ccc',
  fontSize: '14px',
  fontFamily: 'inherit',
  resize: 'vertical',
  minHeight: '80px',
  boxSizing: 'border-box',
},
  page: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    // background: "#fafafa",
    minHeight: "100vh",
    marginTop: "50px",
    paddingBottom: 24,
  },
  breadcrumbWrap: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    background: "#fff",
    padding: "10px 16px",
    borderBottom: "1px solid #eee",
    display: "flex",
    alignItems: "center",
  },
  breadcrumbLink: { color: "#ee6521", textDecoration: "none", fontWeight: 600 },

  container: {
    marginTop: -64,
    display: "flex",
    gap: 16,
    // padding: "12px 16px",
  },

  sidebar: {
    flex: "2",
    minWidth: 240,
    maxHeight: "100vh",
    overflowY: "auto",
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: 12,
    padding: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
  itemsSection: {
    flex: "7",
    minWidth: 240,
    maxHeight: "100vh",
    overflowY: "auto",
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: 12,
    padding: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
  },
  selectedSection: {
    flex: "3",
    minWidth: 240,
    maxHeight: "100vh",
    overflowY: "auto",
    scrollbarWidth: 'none',
    background: "#f7faff",
    border: "1px solid #e5edff",
    borderRadius: 12,
    padding: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
  },

  heading: { fontSize: 18, fontWeight: 700, marginBottom: 8, color: "#222" },

  filterBlock: { marginBottom: 14 },
  filterTitle: { fontWeight: 700, marginBottom: 6 },
  filterOptions: { display: "flex", flexDirection: "column", gap: 6 },
  filterOptionsRowWrap: { display: "flex", flexWrap: "wrap", gap: 6 },
  filterChips: { display: "flex", gap: 8, flexWrap: "wrap" },

  optionRow: { display: "flex", alignItems: "center", gap: 8 },
  checkbox: { width: 16, height: 16, accentColor: "#28a745" },
  radio: { width: 16, height: 16, accentColor: "#ee6521" },

  itemsHeader: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  search: {
    flex: 1,
    maxWidth: 360,
    border: "1px solid #e1e1e1",
    borderRadius: 8,
    padding: "10px 12px",
    outline: "none",
  },

  itemsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(212px, 1fr))",
    gap: 12,
  },
  card: {
    border: "1px solid #eee",
    borderRadius: 12,
    padding: 12,
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
  },
  cardTopRow: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 },
  itemName: { fontWeight: 600 },

  metaRow: { display: "flex", gap: 6, flexWrap: "wrap" },
  metaBadge: {
    background: "#f4f4f5",
    color: "#555",
    fontSize: 12,
    padding: "3px 8px",
    borderRadius: 999,
    border: "1px solid #eee",
  },

  priceRow: { display: "flex", alignItems: "center", justifyContent: "space-between" },
  price: { fontWeight: 700 },

  qtyRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "#f6f6ff",
    borderRadius: 999,
    padding: "4px 6px",
    border: "1px solid #e9e7ff",
  },
  qtyBtn: {
    width: 28,
    height: 28,
    borderRadius: 8,
    border: "1px solid #d8d6ff",
    background: "#fff",
    cursor: "pointer",
    fontWeight: 700,
  },
  qtyVal: { minWidth: 20, textAlign: "center", fontWeight: 700 },

  actionBar: {
    marginTop: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 8,
    borderTop: "1px solid #eee",
  },

  selectedList: { display: "flex", flexDirection: "column", gap: 8, flex: 1, overflowY: "auto" },
  selectedRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 10px",
    border: "1px solid #e6ecff",
    background: "#fff",
    borderRadius: 10,
  },
  selectedQty: { display: "flex", alignItems: "center", gap: 6 },
  qtyBtnMini: {
    width: 24, height: 24, borderRadius: 6, border: "1px solid #d8d6ff", background: "#fff", cursor: "pointer",
  },
  qtyValMini: { minWidth: 18, textAlign: "center", fontWeight: 700 },

  totalsBox: {
    marginTop: 10,
    border: "1px dashed #cdd6ff",
    borderRadius: 12,
    padding: 10,
    background: "#f8f9ff",
  },
  totalLine: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 },

  rightButtons: { marginTop: 10, display: "flex", gap: 8 },

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    background: "#fff",
    borderRadius: 12,
    padding: 20,
    width: "80%",
    maxHeight: "90vh",
    overflowY: "auto",
  },
  categoryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "16px",
    marginBottom: "20px",
  },
  categoryCard: {
    background: "#f9f9f9",
    borderRadius: 10,
    padding: "12px 16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  categoryTitle: {
    marginBottom: 10,
    fontSize: 16,
    fontWeight: 600,
    borderBottom: "1px solid #ddd",
    paddingBottom: 6,
  },
  modalItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 0",
    borderBottom: "1px dashed #ddd",
    fontSize: 14,
  },
  qtyRow: {
    fontWeight: 600,
    color: "#333",
  },
  modalTotals: {
    borderTop: "2px solid #eee",
    marginTop: 16,
    paddingTop: 10,
  },
  totalLine: {
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 0",
  },
  modalButtonsRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: 16,
  },
};
